import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { App, URLOpenListenerEvent } from '@capacitor/app'
import { LanguageService } from './services/language/language.service';
import { Network } from '@capacitor/network';
import { PluginListenerHandle } from '@capacitor/core';
import { GlobalService } from './services/global/global.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { NotificationsService } from './services/notifications/notifications.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { StatusBarService } from './services/statusBar/status-bar.service';

import * as firebase from 'firebase/app';
import { UpdateService } from './services/update/update.service';
import { TranslateService } from '@ngx-translate/core';

import { register } from 'swiper/element/bundle';
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy{

  networkListner: PluginListenerHandle;

  constructor(
    private platform: Platform,
    private languageService: LanguageService,
    private statusBarService: StatusBarService,
    private ngZone: NgZone,
    private global: GlobalService,
    private zone: NgZone,
    private router: Router,
    private notificationsService: NotificationsService,
    private updateService: UpdateService,
    private translate: TranslateService

  ) { this.initializeApp();}

  async ngOnInit() {
    this.networkListner = await Network.addListener('networkStatusChange', status => {
    // console.log('Network status changed', status);
      this.ngZone.run(() => {
        this.changeStatus(status);
      });
    });
    const status = await Network.getStatus();
    this.changeStatus(status);
    console.log('Network status:', status);
  }


  ngOnDestroy() {
    if(this.networkListner) this.networkListner.remove();
  }

  async changeStatus(status) {
    if(!status.connected)  this.global.errorToast(this.translate.instant('toast.toastError.nointernet'))
  }


  initializeApp() {
    // for deeplink
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(()=> {
        const domain = environment.domain;
        const pathArray = event.url.split(domain);

        const appPath = pathArray.pop();
        if(appPath){
          this.router.navigateByUrl(appPath);
        }
      });
    });

    this.platform.ready().then(() => {
      firebase.initializeApp(environment.firebase);
      this.languageService.setInitialAppLanguage();

      this.statusBarService.barColorLight();
      this.statusBarService.toggleOverlays();

      GoogleAuth.initialize();
      SplashScreen.hide();

      this.updateService.checkForUpdate();

      // Notification registration
      this.notificationsService.initPush();
    });
  }


}
